module.exports = __webpack_public_path__ + "nauru.svg?b3898a09ba280a085d02bba2f525de32";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/nauru.svg
// module id = 243
// module chunks = 10